import { FormProvider } from "react-hook-form";
import { cn } from "@/app/utils/cn";
import CreditBalanceForm from "./components/CreditBalanceForm";
import { useSelfHiringContext } from "@/app/contexts/SelfHiringContext";
import { Steps } from "./components/Steps";
import { useCreditController } from "./useCreditController";
import { PartnerSimulation } from "./components/partnerSimulation";
import { FinalizationForm } from "./components/FinalizationForm";
import { Formalization } from "./components/Formalization";
import { initialSchema } from "./components/schema";
import { z } from "zod";
import { deformateDate } from "@/app/utils/deformateDate";

type InitialStepData = z.infer<typeof initialSchema>;

export default function Credit() {
  const companyName = import.meta.env.VITE_COMPANY;

  const {
    methods,
    partners,
    hasCrefaz,
    selfHireLinkId,
    updateLead,
    isUpdatingLead,
  } = useCreditController();

  const { step, nextStep } = useSelfHiringContext();

  const handleFirstStep = async () => {
    const values = methods.getValues() as InitialStepData;

    try {
      await updateLead({
        link: selfHireLinkId || "",
        cpf: values.cpf.replace(/\D/g, ""),
        name: values.name,
        phone: values.phone.replace(/\D/g, ""),
        birthDate: deformateDate(values.birthDate),
      });
    } catch {}

    nextStep();
  };

  const steps = {
    1: {
      title: `Faça uma simulação de Empréstimo com a <span class="text-primary">${companyName}</span>`,
      component: (
        <CreditBalanceForm
          onNext={handleFirstStep}
          hasCrefaz={hasCrefaz}
          isUpdatingLead={isUpdatingLead}
        />
      ),
    },
    2: {
      title: `Empréstimo na palma da mão com a <span class="text-primary">${companyName}</span>`,
      component: (
        <PartnerSimulation partners={partners || []} onNext={nextStep} />
      ),
    },
    3: {
      title:
        'Facilitamos o processo para o seu <span class="text-primary">agrado</span>',
      component: <FinalizationForm />,
    },
    4: {
      title: "Proposta Concluída",
      component: <Formalization />,
    },
  };

  return (
    <>
      <FormProvider {...methods}>
        <form
          className="w-full"
          onSubmit={methods.handleSubmit((data) =>
            console.log(data, "submitt"),
          )}
        >
          <div className="mx-auto my-4 flex w-full max-w-7xl flex-col items-center justify-center gap-5 px-4 pt-4">
            <h1
              dangerouslySetInnerHTML={{
                __html: steps[step as keyof typeof steps]?.title || "",
              }}
              className="mx-auto max-w-[400px] text-center text-lg font-bold dark:text-white md:text-2xl"
            />
            <Steps />

            <div className={cn("w-full", step !== 2 && "mx-auto max-w-3xl")}>
              {steps[step as keyof typeof steps]?.component}
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  );
}
